import { ETrafficVolume } from '@safesystem/client-playbook-lib';
import type { Corridor, Segment, Project } from '#data/safesystem/safecurves/contract.js';
import { aadtFromLabel } from '../Countermeasures/aadt';

type Sheeting = NonNullable<Segment['signSheetingType']>;

// Medium or high traffic on the project (see `projectRoad`) recommends high retroreflective sheeting and high-performance paint; an unknown band doesn't.
export function highVolume(road?: Pick<Corridor, 'aadtBand'>): boolean {
	const volume = road && aadtFromLabel(road.aadtBand);
	return volume === ETrafficVolume.Mid || volume === ETrafficVolume.High;
}

export const recommendedSheeting = (road?: Pick<Corridor, 'aadtBand'>): Sheeting =>
	highVolume(road) ? 'High retroreflective' : 'Standard';

export const recommendedPaint = (road?: Pick<Corridor, 'aadtBand'>): Project['paintType'] =>
	highVolume(road) ? 'High-performance' : 'Standard';

// A null segment sheeting follows the project's recommendation; only a user choice stores a value.
export const resolveSheeting = (
	segment: Pick<Segment, 'signSheetingType'>,
	road?: Pick<Corridor, 'aadtBand'>
): Sheeting => segment.signSheetingType ?? recommendedSheeting(road);

// The same sign/plaque countermeasure code in the other sheeting variant (see the countermeasure constants).
export function signCodeFor(code: string, highRetro: boolean): string {
	const base = code.replace(/-(std|high-retro)$/, '');
	if (base === 'new-sign') return highRetro ? 'new-sign-high-retro' : 'new-sign-std';
	if (base === 'chevron') return highRetro ? 'chevron-high-retro' : 'chevron-std';
	return highRetro ? `${base}-high-retro` : base;
}

export const isChevron = (s: { advisorySign: string | null }) =>
	(s.advisorySign ?? '').includes('Chevron');
